// Imports
import ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ from "../../../node_modules/html-loader/dist/runtime/getUrl.js";
var ___HTML_LOADER_IMPORT_0___ = new URL("../../assets/images/others/arrow_up-dark.png", import.meta.url);
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<!-- Insert Before Body End -->\n<a\n  href=\"#\"\n  class=\"fixed-bottom translate-middle border-0 end-3 end-sm-0 rounded-circle d-flex text-decoration-none opacity-0\"\n>\n  <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" alt=\"\" />\n</a>\n";
// Exports
export default code;